const faMobileSignalOut = {
  prefix: 'fal',
  iconName: 'mobile-signal-out',
  icon: [
    576,
    512,
    [],
    'e1f0',
    'M336-32c132.5 0 240 107.5 240 240 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 80c0-8.8 7.2-16 16-16 79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112-8.8 0-16-7.2-16-16zM96 0l176 0 0 32-176 0C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-176 32 0 0 176c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64C32 28.7 60.7 0 96 0zm80 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z',
  ],
};
export default faMobileSignalOut;
